/** 사이드바 배지(견적 미처리 건수)를 지금 다시 읽으라는 신호. 견적 상태를 바꾼 화면이 부른다 */
const EVENT = 'admin:summary-refresh'
export function refreshSummary() {
  window.dispatchEvent(new Event(EVENT))
}
export function onSummaryRefresh(fn: () => void): () => void {
  window.addEventListener(EVENT, fn)
  return () => window.removeEventListener(EVENT, fn)
}
